import { loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm, monitoringOff, monitoringOn } from '@assets/images/main/index';
import {
  Icon3d3d,
  Icon3dAlert,
  Icon3dCheck,
  Icon3dCycle,
  Icon3dDetect,
  Icon3DLine,
  Icon3dLocation,
  Icon3dMap,
  Icon3dMap2,
  Icon3dMeter,
  Icon3dSchedule,
  Icon3dServer,
  IconDownload,
} from '@assets/images/icon';
import { IconBlueCircle, IconBlueDevelop, IconBluePlus, IconBlueScan, IconBlueShield } from '@assets/images/main/icon/blue';
import {
  iotBannerBg,
  iotBannerProduct,
  iotScreenshot1D,
  iotScreenshot1M,
  iotScreenshot1T,
  iotScreenshot2D,
  iotScreenshot2M,
  iotScreenshot2T,
  iotScreenshot3D,
  iotScreenshot3M,
  iotScreenshot3T,
} from '@assets/images/main/sensor';
import { IconAirQualityInv, IconBellInv, IconCo2Inv, IconLoraSensorInv } from '@assets/images/main/icon';

export default {
  banner: {
    title: '복잡한 장비, 다양한 데이터,<br/>오브로에서는 하나처럼 작동합니다.',
    desc: '온습도, 공기질, 압력, CO₂, 전력 제어, 안심벨 등<br/>IoT 데이터가 ORBRO OS로 실시간 수집되고 시각화됩니다.',

    schemeTitle: '산업 현장에 꼭 맞는 센서, 오브로가 준비했습니다',
    bgImg: iotBannerBg,
    productImg: iotBannerProduct,
  },

  func: {
    title: '기능 더 알아보기',
    desc: '카메라의 다양한 기능을 확인해 보세요.',

    data: [
      {
        img: IconBlueScan,
        title: '센서 상태 실시간 모니터링',
        desc: '센서의 작동 상태, 배터리 잔량, 연결 신호 세기를 ORBRO OS에서 실시간으로 확인할 수 있습니다.',
      },
      {
        img: Icon3dMap,
        title: '지도 기반 센서 배치 확인',
        desc: '센서가 설치된 위치를 지도나 도면 위에 시각화하여 공간별 상태를 한눈에 확인할 수 있습니다.',
      },
      {
        img: Icon3dSchedule,
        title: '이벤트 기록 및 알림 로그 확인',
        desc: '발생한 이상 이벤트와 발송된 알림 내역을 타임라인으로 확인하고, 원인 분석에 활용할 수 있습니다.',
      },
      {
        img: IconBlueCircle,
        title: '구역별 센서 그룹 관리',
        desc: '센서들을 설치 구역 또는 용도별로 그룹화하여 대시보드에서 직관적으로 관리할 수 있습니다.',
      },
      {
        img: Icon3dMeter,
        title: '이상치 탐지 및 임계값 설정',
        desc: '센서별로 임계값을 설정하면 이를 초과할 경우 자동으로 시스템이 감지하여 알림을 전송합니다.',
      },
      {
        img: Icon3dAlert,
        title: '구역별 알림 조건 차등 설정',
        desc: '위험도가 높은 구역에는 더 민감한 알림 조건을 설정하는 등 구역별 알림 민감도 조절이 가능합니다.',
      },
      {
        img: IconBlueDevelop,
        title: '데이터 이력 저장 및 다운로드',
        desc: '측정값과 이벤트 이력이 자동 저장되며, CSV 또는 Excel로 내보낼 수 있습니다.',
      },
      {
        img: Icon3dServer,
        title: '외부 시스템 연동(API)',
        desc: '출입 통제, 설비 제어 등 외부 시스템과의 연동을 위한 API를 제공하며, 이벤트 트리거 기반 자동화도 가능합니다.',
      },
    ],
  },

  bannerData: [
    {
      icon: loraSensorOn,
      iconInv: IconLoraSensorInv,
      iconOff: loraSensorOff,
      image: '',
      iconText: 'LoRA 센서',
      sub: 'New',
      link: '/iot/LoRASensor',
    },
    {
      icon: coOn,
      iconInv: IconCo2Inv,
      iconOff: coOff,
      image: '',
      iconText: 'CO₂ 측정기',
      sub: 'New',
      link: '/iot/co2',
    },
    {
      icon: airOn,
      iconInv: IconAirQualityInv,
      iconOff: airOff,
      image: '',
      iconText: '공기품질 측정기',
      sub: 'New',
      link: '/iot/air',
    },
    {
      icon: monitoringOn,
      iconInv: IconBellInv,
      iconOff: monitoringOff,
      image: '',
      iconText: '비상벨',
      sub: ' ',
      link: '/iot/bell',
    },
  ],

  screenShot: [
    {
      title: '모든 센서를 한눈에 확인하는 실시간 통합 대시보드',
      desc: '다양한 IoT 센서의 데이터를 ORBRO OS에서 실시간으로 시각화하여<br/>위치와 센서정보를 한 화면에서 직관적으로 관리할 수 있습니다.',
      img: {
        desktop: iotScreenshot1D,
        tablet: iotScreenshot1T,
        mobile: iotScreenshot1M,
      },
    },
    {
      title: '시간의 흐름까지 보여주는 센서 데이터 그래프',
      desc: '센서별 측정값을 시간대별 그래프로 확인해 환경 변화와 이상 징후를 빠르게 파악할 수 있습니다.',
      img: {
        desktop: iotScreenshot2D,
        tablet: iotScreenshot2T,
        mobile: iotScreenshot2M,
      },
    },
    {
      title: '이상 징후가 감지되면 즉시 알림으로 대응 시작',
      desc: '센서가 설정값을 초과하거나 비정상 상태를 감지하면 ORBRO OS가 즉시 관리자에게 알림을 전송해 빠른 대응을 도와줍니다.',
      img: {
        desktop: iotScreenshot3D,
        tablet: iotScreenshot3T,
        mobile: iotScreenshot3M,
      },
    },
  ],

  FAQ: [
    {
      title: '센서 데이터는 얼마나 자주 갱신되나요?',
      description: '기본 설정은 1~5분 간격이며, 센서 종류에 따라 실시간 전송도 지원됩니다.',
    },
    {
      title: '오프라인 환경에서도 작동하나요?',
      description: '일부 센서는 로컬 저장 후 네트워크 복구 시 데이터 전송이 가능합니다.',
    },
    {
      title: '여러 센서를 동시에 설치해도 되나요?',
      description: 'ORBRO OS는 다수의 센서를 동시에 연결·관리할 수 있도록 설계되어 있습니다.',
    },
    {
      title: '외부 장비와도 연동 가능한가요?',
      description: 'API를 통해 제어 시스템, 출입 시스템 등 다양한 장비와 유연하게 연동됩니다.',
    },
    {
      title: '센서 배터리는 얼마나 오래가나요?',
      description: '제품에 따라 다르지만, LoRa 센서는 평균 6개월~1년 이상 사용 가능하며 배터리 상태도 실시간 확인됩니다.',
    },
    {
      title: '모든 센서가 ORBRO OS에 연동되나요?',
      description: 'ORBRO 인증 제품은 모두 자동 연동되며, Modbus, RS-485 등 통신 방식이 맞는 타사 센서도 일부 연동 가능합니다.',
    },
    {
      title: '센서 오작동 시 알림을 받을 수 있나요?',
      description: '네. 신호 끊김, 배터리 부족 등 비정상 상황도 시스템이 자동 감지하여 알림을 보냅니다.',
    },
    {
      title: '알림을 여러 명이 동시에 받을 수 있나요?',
      description: '가능합니다. 부서별 또는 역할별로 알림 수신자 그룹을 설정할 수 있습니다.',
    },
  ],
};
